import SSRIcon from "@ingka/ssr-icon";
import warningIcon from "@ingka/ssr-icon/paths/warning-triangle-orange";
import Tooltip from "@ingka/tooltip";

export function WarningInfo({ text }: { text: string }) {
  return (
    <Tooltip position="top" tooltipText={text}>
      <SSRIcon paths={warningIcon} className="h-[1.1rem] w-[1.1rem]" />
    </Tooltip>
  );
}
